module.exports = __webpack_public_path__ + "public/img/wechat-icon.71a212ca.png";